<sh-form-group
    *ngIf="profileField$ | async as profileField"
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [required]="profileField.Required"
    [helpText]="profileField.Description"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [title]="disabledMessageKey | translate"
    [labelActionItems]="globalActionItems$ | async"
>
    <p *ngIf="isIndeterminate" class="sh-form-group__feedback">{{ "general.only-matching-values-shown" | translate }}</p>

    <!-- Merge Strategy Component-->

    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <form [formGroup]="list" [id]="profileField.DottedKey">
        <ng-container *ngFor="let currentValueFormGroup of list.controls; let i = index">
            <div class="sh-form-group sh-child-field-group" [style]="nestedPadding$ | async">
                <div class="sh-action-group" style="margin-bottom: 0px">
                    <div class="sh-action-group__item">
                        <label
                            ><i>{{ childDefinitionLabel$ | async }} {{ i + 1 }}</i></label
                        >
                    </div>
                    <div *ngIf="childActionItems$ | async as actionItems" class="sh-action-group__item">
                        <sh-action-item *ngFor="let actionItem of actionItems[i]" [item]="actionItem"></sh-action-item>
                    </div>
                </div>
                <ng-container *ngFor="let grandChildProfileField of grandChildProfileFields$ | async">
                    <sh-generic-field
                        *ngIf="grandChildProfileField.FieldDefinition; else notFound"
                        [profileField]="grandChildProfileField"
                        [formGroup]="currentValueFormGroup"
                        [records]="[flattenedComplexListFieldRecords[i]]"
                        [isBatchEdit]="isBatchEdit"
                        [canEditStandard]="canEdit$ | async"
                        [canEditAdvanced]="canEdit$ | async"
                        [nestedIndex]="(nestedIndex$ | async)! + 1"
                        [autocompleteFct]="undefined"
                    >
                    </sh-generic-field>

                    <ng-template #notFound>
                        <dt class="sh-description-list__term">{{ grandChildProfileField.DisplayLabel }}</dt>
                        <dd class="sh-description-list__details">
                            {{ "form.error.fielddefinition-not-found" | translate: { id: grandChildProfileField.FieldDefinitionId } }}
                        </dd>
                    </ng-template>
                </ng-container>
            </div>
        </ng-container>
    </form>
</sh-form-group>
